import React, {useState} from "react";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Button from "@material-ui/core/Button";
import {calcPrice} from "ecommerce-commons-ui/core/utils";
import ProductDescriptionWidget from "../../../components/ProductDescriptionWidget";
import "./style.styl";


export default function CartContent(props){
    const {items, isMobile, mediaPath, noImage, ecommerceStoreId, apiPath, location} = props;
    const [selected, setSelected] = useState("")
    const total = items.reduce((a, b) => a + (calcPrice(b).final_price || 0) * (parseInt(b.quantity || "1")), 0).toFixed(2);

    console.log(123456, items)
 
    return (
        <div className="u-flexColumn u-sizeFullWidth">
            <div className="u-flexColumn  u-sizeFullWidth u-maxWidth600">
                <div className="u-flexColumn u-backgroundColorWhite u-borderRadius10 u-sizeFullWidth u-maxWidth600">
                    <List className="cart-content u-paddingTop0">
                        {
                            items.map((product, i) => {
                                const {price, price_fixed, discount_fixed, discount_percent} = calcPrice(product);
                                const path = product.images ? mediaPath + (product.images || "").split(",")[0] : (noImage || "https://assets.smallcase.com/images/smallcases/200/SCSB_0004.png");
                                return (
                                    <ListItem key={i} className="u-padding0">
                                        <div className="u-flexCenter u-sizeFullWidth u-paddingVertical2">
                                        <div className="u-relative u-inlineBlock u-marginVertical4 u-verticalAlignTop u-marginRight15">
                                                <div className={"image-widget-item u-relative u-cursorPointer"} onClick={() => setSelected(product["ecommerce_product_id"] || "")}
                                                    style={{backgroundImage: `url(${path})`, width: "100px", height: "60px", backgroundSize: "fill"}}></div>
                                            </div>
                                            <div className={"u-flexColumn"}>
                                            
                                                
                                                <div className="u-flexCenter u-fontSize14 u-textColorDarker" onClick={() => setSelected(product["ecommerce_product_id"] || "")}>
                                                    <span className="u-marginRight10 u-xs-marginRight0 link u-cursorPointer">{product.name}</span>
                                                </div>
                                                <div className="u-fontSize15 u-textColorDarker u-flexCenter u-marginTop5">
                                                    <div className="u-flexCenter u-hide">
                                                        <div    className={"u-flexCenter u-fontWeightBold u-fontSize15"}>
                                                            $ {discount_percent ? discount_fixed : price_fixed}
                                                        </div>
                                                        {
                                                            discount_percent ?
                                                                <div className="u-flexCenter u-marginLeft10">
                                                                    <div    className={"u-flexCenter u-fontSize9"}
                                                                            style={{color: "#9d9ca5", textDecoration: "line-through"}}>
                                                                        $ {price_fixed}
                                                                    </div>
                                                                    <div className="discount_percent u-marginLeft5">
                                                                        {discount_percent}%
                                                                    </div>
                                                                </div>
                                                                :
                                                                null
                                                        }
                                                    </div>

                                                    <div className="u-fontSize13 u-flexCenter">
                                                        qty: {product.quantity || "1"}
                                                    </div>
                                                    <Button size="small" onClick={() => setSelected(product["ecommerce_product_id"] || "")} className="u-padding2 u-height20 u-fontSize8 u-marginLeft10 u-hide" variant="outlined">
                                                        details
                                                    </Button>
                                                </div>
                                            </div>
                                        </div>
                                    </ListItem>
                                );
                            })
                        }
                    </List>
                    <div className="cart-actions">
                        <div className="u-sizeFullWidth u-paddingTop15 u-flexCenter u-justifyContentSpaceBetween u-borderTop1 u-borderColorLightest">
                            <div className="u-sizeFullWidth u-flexCenter u-justifyContentCenter u-fontSize18">
                                <div className="u-fontSize20 u-border0 u-borderColorLighter u-borderRadius5 u-padding">Price: <span className="u-fontWeightBold">$ {total}</span></div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <ProductDescriptionWidget
                ecommerceStoreId={ecommerceStoreId}
                apiPath={apiPath}
                mediaPath={mediaPath}
                open={!!selected}
                productId={selected}
                onClose={() => setSelected("")}
                mode={"simple"}
                location={location}
                isMobile={isMobile}
                isFullscreen={isMobile}
                />
        </div>
    );
}
